import React from 'react';
import ReactApexChart from 'react-apexcharts';

class PieChart extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      chartData: [],
      chartOptions: {},
    };
  }

  componentDidMount() {
    const { chartData, chartOptions } = this.props;
    this.setState({
      chartData,
      chartOptions,
    });
  }

  render() {
    const { chartData, chartOptions } = this.state;

    return (
      <ReactApexChart
        options={chartOptions}
        series={chartData}
        type="pie"
        width="100%"
        height="55%"
      />
    );
  }
}

export default PieChart;
